import { render, staticRenderFns } from "./locale_switcher.vue?vue&type=template&id=cb34a8b4"
import script from "./locale_switcher.vue?vue&type=script&lang=js"
export * from "./locale_switcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports